<div class="content">
  <div *ngIf="isLoading()" class="loading">
    <mat-progress-spinner color="primary" mode="indeterminate" diameter="101">
    </mat-progress-spinner>
  </div>  
  <div class="body" *ngIf="!isLoading()">
    <div class="header">
      <div class="patient-info">
        <div class="patient-avatar" (click)="toggleTimeline($event)" [style.background-color]="getColorFromName(null, true)">
          {{getFamilyInitials()}}
        </div>
        <div class="patient-identification">
          <div class="title-line" *ngIf="family">
            <div class="page-title">{{getFamilyName()}} ({{sanitizeIdentifier(family.identifier)}}) </div>
          </div>
          <div class="patient-header" *ngIf="family">
            <patient-tags [sourceTags]="resolvePrimary().tags" [entityId]="family.id" [context]="'FAMILY'"></patient-tags>
            <u>{{family.status | titlecase}}</u> Primary: {{getPatientName(resolvePrimary())}} &bull; Identifier: {{sanitizeIdentifier(family.identifier)}} &bull; {{getAddress()}} &bull;  {{getPhone()}}     
            <button  (click)="onEdit()" mat-icon-button >
              <mat-icon class="edit-button">edit</mat-icon>
            </button>
            <div class="family-details">
              <span class="header-heading">Service level:</span>
                <span>{{getServiceLevel()}}</span>
              <span   class="header-heading">Teams:</span>
              <span>{{getTeamsAsString()}} </span>
               <span class="header-heading">Evaluations:</span> 
               <span *ngIf="family.evaluationLatenessState != undefined">
              <mat-icon [ngClass]="family.evaluationLatenessState === 2 ? 'lateness-red' : family.evaluationLatenessState === 1 ? 'lateness-yellow' : 'lateness-green'">how_to_reg</mat-icon>
            </span>
            <span *ngFor="let dt of getEvaluationDates()">{{dt | date:'mediumDate'}}&nbsp;</span></div>
          </div>
         

        </div>
    </div>
    <div class="tabs">
      <button mat-button class="body-standard-tab" [ngClass]="{selected: tabIndex == 0}" (click)="setTab(0)">Patients</button>
      <button mat-button class="body-standard-tab" [ngClass]="{selected: tabIndex == 1}" (click)="setTab(1)">Appointments<span *ngIf="family.hasLateAppointments" class="late-style"><mat-icon>notification_important</mat-icon></span></button>
      <div>
        <button mat-button class="body-standard-tab" [ngClass]="{selected: tabIndex == 2}" (click)="setTab(2)">Checklists</button>
      </div>
      <div>
        <button mat-button class="body-standard-tab" [ngClass]="{selected: tabIndex == 3}" (click)="setTab(3)">Compasses</button>
      </div>
      <button mat-button class="body-standard-tab" [ngClass]="{selected: tabIndex == 4}" (click)="setTab(4)">History</button>
    </div>
    <div class="tab-container" *ngIf="tabIndex === 0">
      <family-patients [family]="family"></family-patients>
     </div> 
    <div class="tab-container" *ngIf="tabIndex === 1">
      <family-appointments [family]="family" [checklistTemplates]="checklistTemplates"   [user]="user" [appointments]="appointments"></family-appointments>
    </div>
    <div class="tab-container" *ngIf="tabIndex === 2">
      <family-checklist-view [family]="family" [checklistTemplates]="checklistTemplates"   [user]="user" [appointments]="appointments" ></family-checklist-view>
    </div> 
    <div class="tab-container" *ngIf="tabIndex === 3">
      <compass-tab [family]="family" [scoredCompasses]="scoredCompasses" (editingDone)="getGuidanceSubs()"></compass-tab>
    </div> 
    <div class="tab-container" *ngIf="tabIndex === 4">
     <family-history [history]="family.changeHistories"></family-history>
    </div> 
  </div>
</div>